<template>
    <div class="flex min-h-full flex-1 flex-col justify-start px-6 py-12 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2 class="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Sign in to your account</h2>
        </div>

        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form class="space-y-6" action="#" method="POST" @submit.prevent="submitForm">
                <div v-if="errors?.email?.length || errors?.general?.length" class="mb-4 text-sm text-red-600">
                    {{ errors.email?.[0] || errors.general?.[0] }}
                </div>
                <div v-if="!success?.message" class="mb-4 text-sm text-green-600">
                    <div class="mt-2">
                        <FloatLabel variant="in" class="w-full">
                            <InputText :invalid="!!errors.email" id="email" v-model="email" variant="filled" class="w-full" type="email" />
                            <label for="email">Your email</label>
                        </FloatLabel>
                    </div>
                </div>

                <div v-else class="mb-4 text-sm text-green-600">
                    {{ success.message }}
                </div>

                <div>
                    <Button class="w-full" type="submit" variant="primary" :loading="loading">
                        Send reset link
                    </Button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import InputText from 'primevue/inputtext';
import FloatLabel from 'primevue/floatlabel';
import Button from 'primevue/button';
import { ref } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useRouter } from 'vue-router';

const email = ref('');
const loading = ref(false);
const errors = ref({});
const success = ref({});
const route = useRouter();

const submitForm = () => {
    loading.value = true;

    useAuth()
        .forgotPassword(email.value)
        .then(() => {
            success.value = { message: 'Reset link sent successfully. Check your email and follow the instructions.' };
            localStorage.setItem('reset-password-email', email.value);
            // route.push({ name: 'reset-password', query: { reset: 'true' } });
        })
        .catch((error) => {
            if (error.response?.status === 422) {
                errors.value = error.response.data.errors;
            } else {
                errors.value = { general: [error.response?.data?.message] } ?? { general: ['An error occurred during verification.'] };
            }
        })
        .finally(() => {
            loading.value = false;
        });
};

const sendAgain = () => {
    email.value = localStorage.getItem('reset-password-email') || '';
    success.value.message = null;
    submitForm();
};
</script>